/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './strongRef.defs.js'
export { main as default } from './strongRef.defs.js'
